import { useEffect } from 'react';

const TWITTER_WIDGETS_SCRIPT_URL = 'https://platform.twitter.com/widgets.js';
const TWITTER_EMBED_SCRIPT_ATTRIBUTE = 'data-twitter-embed';

// The script stays after unmount: removing it frees nothing and re-adding it reruns widgets.js.
export default function TwitterEmbed() {
  useEffect(() => {
    if (document.querySelector(`script[${TWITTER_EMBED_SCRIPT_ATTRIBUTE}]`)) return;

    const script = document.createElement('script');
    script.src = TWITTER_WIDGETS_SCRIPT_URL;
    script.setAttribute(TWITTER_EMBED_SCRIPT_ATTRIBUTE, 'true');
    script.addEventListener('error', () => script.remove());
    document.body.appendChild(script);
  }, []);

  return null;
}
